export default "__VITE_ASSET__Bb2OqG7m__"